import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import {
  type AutomationsAnalyticsEntrySource,
  type AutomationsAnalyticsPromptMode,
  type AutomationsAnalyticsScheduleRepeat,
  withAutomationsCategory,
} from './automationsAnalytics';
import META from './useTrackAutomationCreated.meta';

export type UseTrackAutomationCreatedParams = {
  entry_source: AutomationsAnalyticsEntrySource;
  prompt_mode: AutomationsAnalyticsPromptMode;
  schedule_repeat?: AutomationsAnalyticsScheduleRepeat;
};

export const useTrackAutomationCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationCreated = useCallback(
    (params: UseTrackAutomationCreatedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationCreated };
};
